const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({
      to: '/login'
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});